import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import MspAnalyticsApi from "../apis/mspAnalyticsApi";
import { getApiErrorMessage } from "../utils/apiErrorMessage";
import CachedTicketAnalysisPanel, { CachedTicketAnalysisPanelProps } from "./CachedTicketAnalysisPanel";
import RecentTicketAnalysisPanel from "./RecentTicketAnalysisPanel";

export type DashboardTicketAnalysisPanelProps = CachedTicketAnalysisPanelProps;

export default function DashboardTicketAnalysisPanel(props: DashboardTicketAnalysisPanelProps) {
  const historical = !!props.dashboardCacheDay && props.dashboardCacheDay !== new Date().toISOString().slice(0, 10);
  const [mode, setMode] = useState<"live" | "cached" | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (historical) return;
    let cancelled = false;
    setError(null);
    setMode(null);
    MspAnalyticsApi.loadTicketAnalysisSource().then(source => {
      if (!cancelled) setMode(source.mode);
    }).catch(err => {
      if (!cancelled) setError(getApiErrorMessage(err, "Unable to load ticket analysis."));
    });
    return () => { cancelled = true; };
  }, [historical, attempt]);
  if (historical || mode === "cached") return <CachedTicketAnalysisPanel {...props} />;
  if (mode === "live") return <RecentTicketAnalysisPanel />;
  if (error) return <Alert severity="error" action={<Button onClick={() => setAttempt(value => value + 1)}>Retry</Button>}>{error}</Alert>;
  return <Box sx={{ py: 4, textAlign: "center" }}><CircularProgress size={28} aria-label="Loading ticket analysis" /></Box>;
}
